import axios from 'axios'
import {
  AttachmentConnectedPlatformListResponse,
  ReceiptAttachmentResponse,
} from 'src/models/receiptAttachment.models'
import { getResponseData } from 'src/queries/network.utils'
import { getRequestConfig, RequestConfig } from 'src/queries/requestConfig'

export type PostERPReceiptAttachmentsParams = {
  orgId: string
  connectionId: string
  transactionId: string
}

export const postReceiptAttachment = async (
  formData: FormData,
): Promise<ReceiptAttachmentResponse> =>
  getResponseData(
    axios.post<ReceiptAttachmentResponse>(
      '/receiptattachments',
      formData,
      getRequestConfig(RequestConfig.Form),
    ),
  )

export const postERPReceiptAttachments = async ({
  orgId,
  connectionId,
  transactionId,
}: PostERPReceiptAttachmentsParams): Promise<
  AttachmentConnectedPlatformListResponse[]
> =>
  getResponseData(
    axios.post<AttachmentConnectedPlatformListResponse[]>(
      `/organizations/${orgId}/connections/${connectionId}/attachments/push`,
      { transactionId },
      getRequestConfig(RequestConfig.Default),
    ),
  )
